import {
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    Divider,
    Modal,
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { useLocation } from "react-router-dom"; import nopdf from '../../../assets/images/nopdf.png'

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "180vh",
    height: "85vh",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};


type Props = {};

const DocMngEdit = (props: Props) => {
   

    console.log()
    let navigate = useNavigate();
    const { i18n, t } = useTranslation();

    const [toaster, setToaster] = useState(false);
    const location = useLocation();
    console.log('location', location.state)



   

    const formik = useFormik({
        initialValues: {
            fileID: location.state.fileID,
           
            fileNo: location.state.fileNo,
            
            periodFrom: location.state.periodFrom,
            periodUpto: location.state.periodUpto,


        },



       
        onSubmit: async (values) => {
            const response = await axios.post(
                HOST_URL.HOST_URL2 + `FileDetail/AddUpdateFileDetails`,
                values
            );
            if (response.data.isSuccess) {
                setToaster(false);
                toast.success(response.data.mesg);
                navigate('/DocManagement/DocMng');
            } else {
                setToaster(true);
                toast.error(response.data.mesg);

            }

        }
    });

    

    const back = useNavigate();

    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    border: ".5px solid #FF7722",
                    marginTop: "3vh"
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        Doc Mng Edit
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        {toaster === false ? "" : <ToastApp />}
                        <Grid item xs={12} container spacing={2}>
                           
                            

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="fileNo"
                                    name="fileNo"
                                    label="File No"
                                    value={formik.values.fileNo}
                                    placeholder="File No"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>


                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="periodFrom"
                                    name="periodFrom"
                                    label="Period From"
                                    value={formik.values.periodFrom}
                                    placeholder="From Page"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="periodUpto"
                                    name="periodUpto"
                                    label="Period Upto"
                                    value={formik.values.periodUpto}
                                    placeholder="toPage"
                                    size="small"
                                    type="number"
                                    inputProps={{ maxLength: 10 }}
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={(e) => {
                                        console.log("chcek", e.target.value)
                                        formik.setFieldValue("periodUpto", e.target.value)
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>






                           






                            <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#059669",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t("text.save")}
                                    </Button>
                                </Grid>

                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="reset"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#F43F5E",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                        onClick={(e) => formik.resetForm()}
                                    >
                                        {t("text.reset")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>

                </CardContent>
            </div>
        </div>
    );
};

export default DocMngEdit;